import React, { useEffect, useState } from 'react';
import MoleMappingSpace from './MoleMappingSpace';
import MoleMappingSpaceMobile from './MoleMappingSpaceMobile';

/**
 * Wrapper component that detects device type and renders appropriate version
 */
const MoleMappingSpaceWrapper: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);
  
  useEffect(() => {
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileDetected = /android|webos|iphone|ipad|ipod|blackberry|windows phone/.test(userAgent);
      
      // Also check screen width as additional indicator
      const isSmallScreen = window.innerWidth < 768;
      
      const isMobileDevice = mobileDetected || isSmallScreen;
      console.log('Device detection:', {
        userAgent,
        mobileDetected,
        isSmallScreen,
        windowWidth: window.innerWidth,
        isMobileDevice
      });
      
      setIsMobile(isMobileDevice);
    };
    
    checkMobile();
    
    // Re-check on window resize
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  
  // Show loading or determine which component to render
  console.log('Rendering:', isMobile ? 'Mobile' : 'Desktop', 'version');
  return isMobile ? <MoleMappingSpaceMobile /> : <MoleMappingSpace />;
};

export default MoleMappingSpaceWrapper;
